import { SectionTab } from '../../../components/navigation/SectionTabs';

/**
 * Onglets de l'entrée Statistiques : Analytics et statistiques des flows,
 * deux écrans qui avaient chacun leur entrée de menu.
 */
export const STATS_TABS: SectionTab[] = [
    { to: '/super-admin/analytics', label: 'Général', end: true },
    { to: '/super-admin/flow-stats', label: 'Flows', end: true },
    { to: '/super-admin/flow-stats/tagging', label: 'Catégorisation des flows' },
    { to: '/super-admin/housekeeping-messaging', label: 'Messagerie ménage' },
];
